//
//
//
//
//
//
//

    export default {
    name: 'pageNotFound',
    data() {
        return {
            title: '页面跑到火星去了',
        };
    },
};



// WEBPACK FOOTER //
// ./src/components/wrong.vue